import router from '../router';
const CryptoJS = require('crypto-js');

const getTokenParams = token => {
  let obj = {};

  if (token) {
    const base64 = token.split('.')[1];
    const words = CryptoJS.enc.Base64.parse(base64);
    const parseStr = words.toString(CryptoJS.enc.Utf8);

    obj = JSON.parse(parseStr);
  }
  return obj;
};

const goLogin=()=> {
    router.push('/');
  }

  const clearIdToken=()=> {
    sessionStorage.removeItem('idToken');
  }
  const getIdToken=()=> {
    return sessionStorage.getItem('idToken');
  }

export const addPublicParams = () => {
    let idToken = getIdToken();
console.log(idToken)
    if (!idToken) {
      goLogin();
      return;
    }
    const obj = getTokenParams(idToken);
    const expTime = obj.exp * 1000;
    const now = Date.now();

    if (expTime <= now) {
      clearIdToken();
      goLogin();
      return;
    }

  return {
    token: idToken
  };
};
